module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width'
  }, [_c('div', {
    staticClass: "logoFlex"
  }, [(!_vm.collapsed) ? _c('img', {
    staticStyle: {
      "width": "50px",
      "height": "46px"
    },
    attrs: {
      "src": require("../images/IndLogo.png")
    },
    on: {
      "click": function($event) {
        return _vm.goHome('/homePage')
      }
    }
  }) : _c('img', {
    staticStyle: {
      "width": "49px",
      "height": "43px"
    },
    attrs: {
      "src": require("../images/IndLogo.png")
    },
    on: {
      "click": function($event) {
        return _vm.goHome('/homePage')
      }
    }
  }), _vm._v(" "), (!_vm.collapsed) ? _c('div', {
    staticClass: "collImg"
  }, [_vm._v(_vm._s(_vm.platName ? _vm.platName : '运营平台'))]) : _vm._e()]), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "flex_righs",
    staticStyle: {
      "flex": "1"
    }
  }, [(_vm.$route.query.idChilds) ? _c('div', {
    staticClass: "title title_updata"
  }, [_vm._v("编辑子系统")]) : _c('div', {
    staticClass: "title title_name"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), (_vm.goBack2 == 'true') ? _c('div', {
    staticClass: "goOrder"
  }, [_c('el-button', {
    on: {
      "click": _vm.goOrder
    }
  }, [_vm._v("返回上一页")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo shipeis",
    attrs: {
      "span": 2
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.sysUserName) + "\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "top": "40px"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [(_vm.setButton) ? _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goSet(1, _vm.plind)
      }
    }
  }, [_vm._v("设置")]) : _c('el-dropdown-item'), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1), _vm._v(" "), (_vm.paltXt.length > 0) ? _c('el-dropdown', {
    staticClass: "tabchild",
    staticStyle: {
      "padding": "0px 20px",
      "float": "right",
      "cursor": "pointer"
    },
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner2"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.platName ? _vm.platName : '请选择子系统') + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    staticStyle: {
      "top": "40px"
    },
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.paltXt), function(item, index) {
    return _c('el-dropdown-item', {
      key: index,
      nativeOn: {
        "click": function($event) {
          return _vm.childernXt(item.adminUrl, item.platId, item.platName)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.platName) + "\n\t\t\t\t\t\t")])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.menuList.length > 0) ? _c('div', {
    staticClass: "yuyings",
    on: {
      "click": function($event) {
        return _vm.goHome2('/homePage', 0)
      }
    }
  }, [_vm._v("运营平台")]) : _c('div')], 1)], 1), _vm._v(" "), (_vm.home) ? _c('div', {}, [_c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "id": "lastclass",
      "text-color": "#FFFFFF",
      "background-color": "#46B4FF",
      "collapse": _vm.collapsed,
      "collapse-transition": "",
      "unique-opened": true
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [(_vm.childIndex) ? [_vm._l((_vm.routes), function(item, index) {
    return [(!item.redirect && item.children && item.children.length) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon != '' && item.icon && item.icon != 'undefined') ? _c('span', [_c('div', {
      staticClass: "icons"
    }, [_c('img', {
      attrs: {
        "src": _vm.img + item.icon
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((item.children), function(items) {
      return [(typeof items.hidden !== 'boolean') ? _c('el-menu-item', {
        key: items.path,
        attrs: {
          "index": items.path
        },
        on: {
          "click": function($event) {
            return _vm.tourles(items.path)
          }
        }
      }, [(items.icon != '' && items.icon && items.icon != 'undefined') ? _c('span', [_c('div', {
        staticClass: "icons"
      }, [_c('img', {
        attrs: {
          "src": _vm.img + items.icon
        }
      })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.name))])]) : _vm._e()]
    })], 2)], 2) : _vm._e()]
  })] : (_vm.cookie < 2 && !_vm.$route.path.includes('setings')) ? [_vm._l((_vm.routes), function(item, index) {
    return [(!item.redirect && item.children && item.children.length) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon != '' && item.icon && item.icon != 'undefined') ? _c('span', [_c('div', {
      staticClass: "icons"
    }, [_c('img', {
      attrs: {
        "src": _vm.img + item.icon
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('el-menu-item-group', [_vm._l((item.children), function(items) {
      return [(typeof items.hidden !== 'boolean') ? _c('el-menu-item', {
        key: items.path,
        attrs: {
          "index": items.path
        },
        on: {
          "click": function($event) {
            return _vm.tourles(items.path)
          }
        }
      }, [(items.icon != '' && items.icon && items.icon != 'undefined') ? _c('span', [_c('div', {
        staticClass: "icons"
      }, [_c('img', {
        attrs: {
          "src": _vm.img + items.icon
        }
      })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.name))])]) : _vm._e()]
    })], 2)], 2) : _vm._e()]
  })] : (_vm.cookie >= 2 && !_vm.$route.path.includes('setings') && !_vm.childIndex) ? _vm._l((_vm.fromRouterData[0].childMenu), function(item) {
    return _c('el-submenu', {
      key: item.funcName,
      attrs: {
        "index": item.funcName,
        "unique-opened": ""
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon != '' && item.icon && item.icon != 'undefined') ? _c('span', [_c('div', {
      staticClass: "icons"
    }, [_c('img', {
      attrs: {
        "src": _vm.img + item.icon
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.funcName))])]), _vm._v(" "), _vm._l((item.childMenu), function(items, index1) {
      return _c('el-menu-item', {
        key: index1 + '',
        attrs: {
          "index": items.funcName
        },
        on: {
          "click": function($event) {
            return _vm.tourles2(items.funcUrl, items.funcName, items.funcName)
          }
        }
      }, [(items.icon != '' && items.icon && items.icon != 'undefined') ? _c('span', [_c('div', {
        staticClass: "icons"
      }, [_c('img', {
        attrs: {
          "src": _vm.img + items.icon
        }
      })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.funcName))])])
    })], 2)
  }) : (_vm.$route.path.includes('setings')) ? _vm._l((_vm.routset), function(item, index) {
    return (!item.redirect && item.children && item.children.length) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon != '' && item.icon && item.icon != 'undefined') ? _c('span', [_c('div', {
      staticClass: "icons"
    }, [_c('img', {
      attrs: {
        "src": _vm.img + item.icon
      }
    })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(items) {
      return _c('el-menu-item', {
        key: items.path,
        attrs: {
          "index": items.path
        },
        on: {
          "click": function($event) {
            return _vm.tourles(items.path)
          }
        }
      }, [(items.icon != '' && items.icon && items.icon != 'undefined') ? _c('span', [_c('div', {
        staticClass: "icons"
      }, [_c('img', {
        attrs: {
          "src": _vm.img + item.icon
        }
      })])]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.name))])])
    })], 2) : _vm._e()
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    class: !_vm.collapsed ? 'zhedeisi' : 'zhedeisi2',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [(_vm.collapsed) ? _c('img', {
    attrs: {
      "src": require("../images/zhankai.png"),
      "alt": "",
      "srcset": ""
    }
  }) : _c('img', {
    attrs: {
      "src": require("../images/shouqi.png"),
      "alt": "",
      "srcset": ""
    }
  }), _vm._v(" "), (_vm.collapsed) ? _c('span', [_vm._v("展开")]) : _c('span', [_vm._v("收起")])])], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container",
    attrs: {
      "id": "content-container"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.plind && !_vm.$route.path.includes('setings') && !_vm.childIndex) ? _c('div', [(_vm.clickStus2) ? _c('div', [(_vm.editableTabs.length <= 0) ? _c('div', [(_vm.separe == 1) ? _c('iframe', {
    ref: "mapFrame",
    attrs: {
      "id": !_vm.collapsed ? 'ifrm1' : 'ifrm1s',
      "src": _vm.admiUrl + '/#',
      "scrolling": "auto",
      "frameborder": "0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.separe == 2) ? _c('iframe', {
    ref: "mapFrame",
    attrs: {
      "id": !_vm.collapsed ? 'ifrm1' : 'ifrm1s',
      "src": _vm.clickStus ? _vm.admiUrl + _vm.ifromUrl : _vm.admiUrl + '/pages/index.html',
      "scrolling": "auto",
      "frameborder": "0"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.separe == 3) ? _c('iframe', {
    ref: "mapFrame",
    attrs: {
      "id": !_vm.collapsed ? 'ifrm1' : 'ifrm1s',
      "src": _vm.admiUrl + '#',
      "scrolling": "auto",
      "frameborder": "0"
    }
  }) : _vm._e()]) : _c('el-tabs', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "type": "card",
      "closable": ""
    },
    on: {
      "tab-remove": _vm.removeTab
    },
    model: {
      value: (_vm.editableTabsValue),
      callback: function($$v) {
        _vm.editableTabsValue = $$v
      },
      expression: "editableTabsValue"
    }
  }, _vm._l((_vm.editableTabs), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    }, [(_vm.separe == 1) ? _c('iframe', {
      ref: "mapFrame",
      refInFor: true,
      attrs: {
        "id": !_vm.collapsed ? 'ifrm2' : 'ifrm2s',
        "src": _vm.clickStus ? _vm.admiUrl + '/#' + item.ifromUrl : _vm.admiUrl + '/#' + item.ifromUrl,
        "scrolling": "auto",
        "frameborder": "0"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.separe == 2) ? _c('iframe', {
      ref: "mapFrame",
      refInFor: true,
      attrs: {
        "id": !_vm.collapsed ? 'ifrm2' : 'ifrm2s',
        "src": _vm.clickStus ? _vm.admiUrl + item.ifromUrl : _vm.admiUrl + item.ifromUrl,
        "scrolling": "auto",
        "frameborder": "0"
      }
    }) : _vm._e(), _vm._v(" "), (_vm.separe == 3) ? _c('iframe', {
      ref: "mapFrame",
      refInFor: true,
      attrs: {
        "id": !_vm.collapsed ? 'ifrm2' : 'ifrm2s',
        "src": _vm.clickStus ? _vm.admiUrl + '#' + item.ifromUrl : _vm.admiUrl + '#' + item.ifromUrl,
        "scrolling": "auto",
        "frameborder": "0"
      }
    }) : _vm._e()])
  }), 1)], 1) : _vm._e()]) : (!_vm.$route.path.includes('setings') || !_vm.plind) ? _c('div', [_c('router-view')], 1) : (_vm.$route.path.includes('setings') && _vm.childIndex) ? _c('div', [_c('router-view')], 1) : (!_vm.childIndex) ? _c('div', [_c('router-view')], 1) : _vm._e()])], 1)], 1)])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2961554e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 731
// module chunks = 87